<template>
  <main>Oops, this page does not exist!<br/>Oops, this page does not exist!<br/>Oops, this page does not exist!<br/>Oops, this page does not exist!<br/>Oops, this page does not exist!<br/>Oops, this page does not exist!<br/>Oops, this page does not exist!<br/>Oops, this page does not exist!<br/></main>
</template>

<script>
export default {
  name: "NotFound"
}
</script>